import { InputAdornment } from '@mui/material';
import React from 'react';
import { Poppins } from 'src/common';
import MaterialInput from 'src/components/form/MaterialInput';
import styled from 'styled-components';
import { NumericFormat } from 'react-number-format';
import { getCurrencySymbol } from 'src/utils/misc';
import { CurrencyInputProps, StyleProps } from './types';

export const MaterialInputCustom = styled(MaterialInput).attrs<StyleProps>(({ currency, currencyPx = 16, ...p }) => {
  return {
    fullWidth: true,
    InputProps: currency
      ? {
          startAdornment: (
            <InputAdornment position="start">
              <Poppins px={currencyPx} weight={500} color="cflowerBlue" style={{ marginBottom: 1 }}>
                {getCurrencySymbol()}
              </Poppins>
            </InputAdornment>
          ),
        }
      : undefined,
    ...p,
  };
})<StyleProps>`
  .MuiInputBase-root {
    background-color: ${({ theme }) => theme.colors.cultured};
  }

  & .MuiInputBase-root {
    padding-left: 10px;
  }

  input {
    padding-left: ${({ currency }) => (currency ? 0 : 8)}px !important;
    padding-right: 6px !important;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      display: none;
    }
  }

  .MuiFormHelperText-root {
    bottom: -20px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    input {
      padding-left: ${({ currency }) => (currency ? 0 : 20)}px;
    }
  }
`;

const CurrencyInput = (props: CurrencyInputProps) => {
  // @ts-ignore
  return <NumericFormat customInput={MaterialInputCustom} thousandSeparator="," {...props} />;
};

export const Symbol = styled(Poppins).attrs((p) => {
  return { px: 16, ...p };
})`
  color: ${({ theme }) => theme.colors.cflowerBlue};
  font-weight: 500;
`;

export default CurrencyInput;
